export const edit = () => {
    return {
        width: '900px',
        title: '编辑流程示意',
        height: '350px',
        ranksep: 75,
        nodesep:30,
        nodes: [
            {
                id: 'start',
                data: { number: 20, label: '编辑合同' },
                type: 'rect',
                style: { size: 60, labelMaxWidth: 45, fill: '#D8D839' },
            },
            {
                id: 'contractStatus',
                data: { label: '判定合同状态' },
                type: 'diamond',
                style: { size: 80, labelMaxWidth: 60, fill: '#DF9931' },
            },

            {
                id: 'checkProjectItems',
                data: { label: '编辑内容中是否删除项目管理系统中已存在项目' },
                type: 'diamond',
                style: { size: [150, 80], labelMaxWidth: 80, fill: '#DF9931' }
            },
            {
                id: 'error1',
                data: { label: '报错提示' },
                type: 'rect',
                style: { size: [120, 40], labelMaxWidth: 80, fill: '#eb0b0b' },
            },
            {
                id: 'success',
                data: { number: 50, label: '编辑成功' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#3CC457' },
            },
            {
                id: 'error2',
                data: { number: 50, label: '报错提示' },
                type: 'rect',
                style: { size: [90, 40], labelMaxWidth: 70, fill: '#eb0b0b' },
            },
        ],
        edges: [
            {
                source: 'start',
                target: 'contractStatus',
                type: 'line',
            },
            {
                source: 'contractStatus',
                target: 'checkProjectItems',
                type: 'polyline',
                data: { label: '待审核合同或已驳回合同' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
            {
                source: 'contractStatus',
                target: 'error1',
                type: 'polyline',
                data: { label: '已通过合同' + `\n` + '审批人: 詹海燕' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                source: 'checkProjectItems',
                target: 'error2',
                type: 'polyline',
                data: { label: '是' },
                style: { sourcePort: 'bottom', targetPort: 'left' }
            },
            {
                source: 'checkProjectItems',
                target: 'success',
                type: 'polyline',
                data: { label: '否' },
                style: { sourcePort: 'top', targetPort: 'left' }
            },
        ],
    };
};